import { parseDate } from "./parseDate";

export function getFormattedTimestamp() {
	const date = new Date();

    const pd = parseDate(date);

	return `${pd.DD}/${pd.MM}/${pd.YYYY} ${pd.HH}:${pd.mm}`;
}
